import withAuthProvider, { AuthComponentProps } from './AuthProvider';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import NavBar from './NavBar';
import ErrorMessage from './ErrorMessage';
import Welcome from './Welcome';
import Administration from './Administration';
import SoftwareUpdates from './SoftwareUpdates';
import OnlineJobs from './OnlineJobs';
import 'bootstrap/dist/css/bootstrap.css';
import axios from "axios";



class App extends Component<AuthComponentProps> {

  state = {
   isAdmin: false,
   adminList: new Array<string>()
  };

  componentDidMount() {
  //Get Admin INformation
  var url = "https://encontech.azurewebsites.net/api/admins";
  //var url = "http://localhost:5000/api/admins";

  axios.get(url).then((response) => {
      
    var al = response.data.map(function(admin: { id: number, email:string }) {
      return admin.email;
    });

      this.setState({
        adminList: al
      })


    });


  }


  render() {

    let error = null;
    if (this.props.error) {
      error = <ErrorMessage
        message={this.props.error.message}
        debug={this.props.error.debug} />;
    }

var isAdmin = this.state.adminList.includes(this.props.email);
console.log("AdminList: " + this.state.adminList)
   console.log("Is Admin: " + isAdmin);

   console.log("EMAIL !!:" +this.props.email);
    return (
      <Router>
        <div>
          <NavBar
            isAuthenticated={this.props.isAuthenticated}
            authButtonMethod={this.props.isAuthenticated ? this.props.logout : this.props.login}
            user={this.props.user}/>
          <div >
            <Switch>
            <Route exact path="/"
              render={(props) =>
                <Welcome {...props}
                  isAuthenticated={this.props.isAuthenticated}
                  user={this.props.user}
                  authButtonMethod={this.props.login} />
               } />
            
            <Route exact path="/OnlineJobs"
              render={(props) => this.props.isAuthenticated ? 
                <OnlineJobs /> :
                <Welcome {...props}
                  isAuthenticated={this.props.isAuthenticated}
                  user={this.props.user}
                  authButtonMethod={this.props.login} />
              } />

<Route exact path="/Administration"
              render={(props) => (this.props.isAuthenticated && isAdmin) ? 
                <Administration {...props}
                  isAuthenticated={this.props.isAuthenticated}
                  user={this.props.user}
                  authButtonMethod={this.props.login}  /> :
                  <Welcome {...props}
                  isAuthenticated={this.props.isAuthenticated}
                  user={this.props.user}
                  authButtonMethod={this.props.login}
                  />
              } />
            
              <Route render={(props) => 
                  <Welcome {...props}
                  isAuthenticated={this.props.isAuthenticated}
                  user={this.props.user}
                  authButtonMethod={this.props.login} />
                } />
              </Switch>
          </div>
          <footer className="greybg overlaytext">
            <div>
            <div className="footerblock">
              <div className="container">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p className="text-center">Technical Support: gdavis@enconmech.com</p>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="text-center container">
                <hr className="borderwhite" />
                Encon Mechanical Copyright © 2021 . All Rights Reserved
              </div>
              <div className="clearfixblock">&nbsp;</div>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    );
  }
}

export default withAuthProvider(App);